// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"516":"c6977ce8","914":"8a243042"}[chunkId] + ".chunk.js";
};